import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiGetV2, getBaseUrl } from '../../support/apiCallHelper';
import { RootState } from '../../app/store';

interface CompanyInformationState {
  logoUrl: string;
  locale: string;
  organizationUnitId?: string;
  status?: 'idle' | 'loading' | 'succeeded' | 'failed';
}

type CompanyAttribute = {
  key: string;
  value: string;
};

const initialState: CompanyInformationState = {
  logoUrl: '',
  locale: 'sv',
  organizationUnitId: '',
  status: 'idle',
};

export const getGATHeaders = (state: RootState) => ({
  gatLocale: state.gatInformation.locale,
  gatOrgUnit: state.gatInformation.organizationUnitId, // om du behöver detta sen – annars ta bort
  appId: process.env.REACT_APP_APPLICATION_ID!,
  accessToken: state.gatSession.accessToken,
});

export const getGATSession = (state: RootState) => ({
  missionId: state.gatSession.missionId,
  token: state.gatSession.token,
});

export const fetchCompanyInformation = createAsyncThunk('companyInformation/fetch', async () => {
  const appId = process.env.REACT_APP_APPLICATION_ID!;
  // const appId = 'gat-rescue-frontend';
  const baseUrl = getBaseUrl();

  const res = await apiGetV2<any>(`${baseUrl}v1/applications,me`, 'version=1.0.0', undefined, {
    'gat-application-id': appId,
  });

  const attributes = res?.companyAttributes?.reduce(
    (acc: Record<string, any>, { key, value }: CompanyAttribute) => {
      acc[key] = value;
      return acc;
    },
    {},
  );

  return {
    logoUrl: attributes?.CompanyLogo ?? null,
    locale: attributes?.CompanyLocale ?? 'sv',
    orgUnitId: res?.organizationUnitId ?? '',
  };
});

const companyInformationSlice = createSlice({
  name: 'companyInformation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyInformation.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCompanyInformation.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.logoUrl = action.payload.logoUrl;
        state.locale = action.payload.locale;
        state.organizationUnitId = action.payload.orgUnitId;
      })
      .addCase(fetchCompanyInformation.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export default companyInformationSlice;
